"use strict"

import Axios from "../../../services/AxiosService"

class Service extends Axios {
  async showBonus() {
    return this.request({
      method: "GET",
      url: "bonus",
    })
  }
}

export default () => new Service()
